import { render, staticRenderFns } from "./info-basic.vue?vue&type=template&id=440bb27d&scoped=true&"
import script from "./info-basic.vue?vue&type=script&lang=js&"
export * from "./info-basic.vue?vue&type=script&lang=js&"
import style0 from "./info-basic.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./info-basic.vue?vue&type=style&index=1&id=440bb27d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440bb27d",
  null
  
)

export default component.exports